import "./Contact.css";
function Contact() {
  return (
    <section className="contact-hero">
      <div className="contact-kicker">ArmorySync support</div>
      <h1 className="title">Questions before or after downloading Range Pocket?</h1>
      <p className="tagline">
        Send product questions, setup feedback, and owner workflow ideas directly to the ArmorySync team.
      </p>

      <div className="contact-grid">
        <a className="contact-card" href="mailto:support@armorysync.com">
          <div className="card-title">Email</div>
          <div className="card-value">support@armorysync.com</div>
          <div className="card-hint">
            Best for product questions and setup feedback.
          </div>
        </a>

        <a
          className="contact-card"
          href="https://www.instagram.com/armorysync/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="card-title">Instagram</div>
          <div className="card-value">@armorysync</div>
          <div className="card-hint">Useful for screenshots and quick product notes.</div>
        </a>

        <a className="contact-card" href="tel:+12067938859">
          <div className="card-title">Phone</div>
          <div className="card-value">+1 (206) 793-8859</div>
          <div className="card-hint">For direct support when email is not enough.</div>
        </a>
      </div>
    </section>
  );
}

export const Contact_Page = {
  path: "/contact",
  element: <Contact></Contact>,
};
